"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'Go to': 'Go to',
            'Items per Page': 'Items per Page',
            'View All': 'View All',
            'of': 'of',
            'Items': 'Items'
        }
    },
    'es': {
        'translation': {
            'Go to': 'Ir',
            'Items per Page': 'Artículos por página',
            'View All': 'Ver todo',
            'of': 'de',
            'Items': 'Artículos'
        }
    },
    'cs': {
        'translation': {
            'Go to': 'Jít na',
            'Items per Page': 'Záznamů na stránce',
            'View All': 'vše',
            'of': 'z',
            'Items': 'Položky'
        }
    },
    'zh': {
        'translation': {
            'Go to': '前往',
            'Items per Page': '每页项目个数',
            'View All': '查看全部',
            'of': '/',
            'Items': '项目'
        }
    },
    'he': {
        'translation': {
            'Go to': 'עבור ל',
            'Items per Page': 'פריטים מתוך עמוד',
            'View All': 'ראה הכל',
            'of': ' מ',
            'Items': ' פריטים'
        }
    }
};
